"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Gabe Kelley, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1650))
 * @trackcomponent
 * @lastsynced 2025-04-16T17:02:15.076Z
 * @optimized using svgo:^3.0.2
 */
export const Edit = createSVGIcon(
  <>
    <path
      d="m12.857 15.386-5.143.908.9-5.151 9.784-9.784a1.714 1.714 0 0 1 2.424 0l1.819 1.82a1.714 1.714 0 0 1 0 2.423z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.572 16.286v5.142a1.714 1.714 0 0 1-1.715 1.715H2.572a1.714 1.714 0 0 1-1.715-1.715V5.143a1.714 1.714 0 0 1 1.715-1.715h5.143"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Edit",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    fill: "none",
    titleAccess: strictLocalize({
      defaultMessage: "Edit",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    color: Core.icon.default,
  })
);
